import React, { useState } from "react";

// Cash vs Pay Online selector, extracted from the pattern used on the
// booking Checkout page (src/pages/Vendor_bookings/Checkout.jsx). "Pay
// Online" is not wired up for vendors yet there either — selecting it shows
// the same "contact admin" explanation and resets back to Cash.
const PAYMENT_METHODS = [
  { id: "cash", label: "Cash", emoji: "💵" },
  { id: "online", label: "Pay Online", emoji: "🔗" },
];

const PaymentMethodSelector = ({ value, onChange, disableOnline = true }) => {
  const [showOnlineDisabledModal, setShowOnlineDisabledModal] = useState(false);

  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        {PAYMENT_METHODS.map((m) => {
          const active = value === m.id;
          return (
            <button
              key={m.id}
              type="button"
              onClick={() => {
                if (m.id === "online" && disableOnline) {
                  setShowOnlineDisabledModal(true);
                } else {
                  onChange(m.id);
                }
              }}
              style={{
                border: `1.5px solid ${active ? "#4f46e5" : "#e2e8f0"}`,
                borderRadius: 11,
                padding: "13px 8px",
                background: active ? "#eef2ff" : "#fafafa",
                cursor: "pointer",
                textAlign: "center",
                transition: "all 0.15s",
              }}
            >
              <div style={{ fontSize: 22, marginBottom: 5 }}>{m.emoji}</div>
              <div style={{ fontWeight: 700, fontSize: 13, color: active ? "#4f46e5" : "#1e293b" }}>
                {m.label}
              </div>
            </button>
          );
        })}
      </div>

      {showOnlineDisabledModal && (
        <div
          style={{
            position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
            background: "rgba(15, 23, 42, 0.5)", zIndex: 9999,
            display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
          }}
        >
          <div style={{ background: "#fff", borderRadius: 16, padding: "24px 26px", maxWidth: 380, boxShadow: "0 8px 30px rgba(0,0,0,0.2)" }}>
            <div style={{ fontSize: 15, color: "#0f172a", marginBottom: 20, lineHeight: 1.5 }}>
              Contact System Admin to enable this capability
            </div>
            <button
              type="button"
              onClick={() => {
                onChange("cash");
                setShowOnlineDisabledModal(false);
              }}
              style={{
                width: "100%", padding: "11px", background: "#d01c4c", color: "#fff",
                border: "none", borderRadius: 10, fontSize: 14, fontWeight: 700, cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentMethodSelector;
